"use client";
import { stemSplitterSessionStorage } from "@/services/storage/stem-splitter-session-storage";
import { stemSplitterLicenseManager } from "@/services/license/license-managers/stem-splitter-license-manager";
import StemSplitterProvider from "@/components/pages/stem-splitter/components/providers/stem-splitter-provider";
import { SplitterProgressProvider } from "@/components/pages/stem-splitter/components/providers/stem-splitter-progress-provider";
import WavesurferProvider from "@/hooks/providers/wavesurfer-provider";
import StemSplitterPage from "@/components/pages/stem-splitter/stem-splitter-page";
import MediaInputProvider from "@/providers/media-input-provider/media-input-provider";
import React from "react";

const StemSplitter = () => {
  return (
    <MediaInputProvider
      sessionStorage={stemSplitterSessionStorage}
      licenseManager={stemSplitterLicenseManager}
    >
      <StemSplitterProvider>
        <SplitterProgressProvider>
          <WavesurferProvider>
            <StemSplitterPage />
          </WavesurferProvider>
        </SplitterProgressProvider>
      </StemSplitterProvider>
    </MediaInputProvider>
  );
};

export default StemSplitter;
